module.exports = __webpack_public_path__ + "static/9-930df9e1367aaf88afb2103e688da5d3.jpg";